export default function GameRates({ rates }) {
  return (
    <section className="bg-dark px-3 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="rates-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-6">
          <div className="label-gold">Premium Payouts</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#ffd700] mt-2">
            Game Rate Chart
          </h2>
        </div>
        <div className="cream-card overflow-hidden">
          {rates.map((r, i) => (
            <div
              key={r.id}
              className={`flex items-center justify-between px-4 sm:px-6 py-3.5 ${
                i % 2 === 0 ? "bg-[#faf1de]" : "bg-[#f0e5d2]"
              } ${i > 0 ? "border-t border-[#e0d3b8]" : ""}`}
              data-testid={`rate-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-display font-bold text-navy text-sm sm:text-lg tracking-wide">
                {r.name}
              </div>
              <div className="flex items-baseline gap-2 sm:gap-3">
                <span className="text-[#6b6455] text-sm">{r.stake}</span>
                <span className="text-[#b8001f] text-lg font-bold">→</span>
                <span className="font-display font-extrabold text-[#b8001f] text-xl sm:text-2xl">
                  {r.payout}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
